import { Navigate } from 'react-router-dom';
import { useAuth } from '@smarty/shared';
import {
  Page,
  Card,
  Text,
  Button,
  BlockStack,
  InlineStack,
  Box,
  Spinner,
  Icon,
} from '@/lib/polaris';
import { AlertCircleIcon } from '@/lib/polaris-icons';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Layout alternativo durante carga (p. ej. AdminLoadingLayout con TopBar + logo). Evita barra negra al refrescar. */
  loadingLayout?: React.ReactNode;
}

export function ProtectedRoute({ children, loadingLayout }: ProtectedRouteProps) {
  const { session, tenantId, loading, signOut } = useAuth();

  if (loading) {
    if (loadingLayout) {
      return <>{loadingLayout}</>;
    }
    return (
      <Page>
        <Box padding="800">
          <InlineStack align="center">
            <BlockStack gap="300" align="center">
              <Spinner size="large" />
              <Text variant="bodyMd" tone="subdued" as="p">
                Cargando...
              </Text>
            </BlockStack>
          </InlineStack>
        </Box>
      </Page>
    );
  }

  // Si no hay sesión, redirigir a login
  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Si hay sesión pero no hay tenant_id, mostrar mensaje de error
  if (!tenantId) {
    return (
      <Page>
        <Box padding="800">
          <InlineStack align="center">
            <Card>
              <BlockStack gap="400">
                <InlineStack gap="200" align="center">
                  <Icon source={AlertCircleIcon} tone="critical" />
                  <Text variant="headingMd" fontWeight="semibold" as="h2">
                    Cuenta sin acceso
                  </Text>
                </InlineStack>
                <Text variant="bodyMd" tone="subdued" as="p">
                  Tu cuenta no está asociada a ningún restaurante.
                </Text>
                <Text variant="bodySm" tone="subdued" as="p">
                  Por favor, contacta al administrador del sistema para que te asigne a un restaurante.
                </Text>
                <Button
                  onClick={async () => {
                    await signOut();
                    window.location.href = '/login';
                  }}
                  variant="secondary"
                >
                  Cerrar sesión
                </Button>
              </BlockStack>
            </Card>
          </InlineStack>
        </Box>
      </Page>
    );
  }

  return <>{children}</>;
}
